import { CountValueFacetItem, Facet } from "./facet.model";

export class BoolFacet extends Facet {
  facetType = "bool";
  constructor(name: string, facets: CountValueFacetItem[], label?: string) {
    super(name, facets, label);
  }

  get selected(): boolean {
    return this.facets.some(d => d.checked);
  }

  get makeSelected(): boolean {
    // not implemented
    return false;
  }

  filterForMake() {
    // not implemented
    return "";
  }

  filter(urlParams: URLSearchParams): string {
    const param = urlParams.get(this.name);
    
    // If there's an explicit query param, respect it
    if (param !== null) {
      if (param === "true") {
        this.update(this.facets);
        this.facets.forEach(d => (d.checked = true));
        return `${this.name} eq true`;
      } else {
        // Explicitly set to false or empty - uncheck and don't filter
        this.uncheck();
        return null;
      }
    }
    
    // No query param - apply route-based default if applicable
    if (this.isForcedByRoute()) {
      this.applyForcedSelection();
      return `${this.name} eq true`;
    }

    this.uncheck();
    return null;
  }

  update = (facets: CountValueFacetItem[], showFalseFacet: boolean = false) => {
    // if this is selected do not update
    if (this.selected) {
      try {
        if (this.name == "buyItNowEnabled") {
          const buyItNowFacet = this.facets.find(d => d.label == "Buy It Now");
          if (buyItNowFacet) {
            buyItNowFacet.count = facets[0].count;
          }
        }

        if (this.name == "rpoEnabled") {
          const rentToOwnFacet = this.facets.find(d => d.label == "Rent to Own");
          if (rentToOwnFacet) {
            rentToOwnFacet.count = facets[0].count;
          }
        }
      } catch (e) {
        // do nothing for right now this is only to update the count
      }

      return;
    }

    const trueFacet = facets.find(d => d.value === true);
    // if we do not have a true facet we need to return because we do not want to show
    if (!trueFacet) {
      this.facets = [];
      return;
    }

    trueFacet.label = this.label;
    this.facets = showFalseFacet ? facets : [trueFacet];
  };

  toQueryParam = (): string => {
    if (this.selected) {
      return this.facets
        .filter(d => d.checked)
        .map(d => d.value)
        .join(":");
    }

    // If this filter was forced by route but is now unchecked, explicitly set to false
    // to override the route default
    if (this.isForcedByRoute()) {
      return "false";
    }

    return undefined;
  };

  private isForcedByRoute(): boolean {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    if (!pathSegments.length) {
      return false;
    }

    if (this.name === "buyItNowEnabled") {
      return pathSegments[0] === "equipment-for-sale";
    }

    // rpoEnabled is no longer forced by route - use query param only
    return false;
  }

  private applyForcedSelection() {
    this.update(this.facets);
    this.facets.forEach(d => (d.checked = true));
  }
}
